import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import { CONNECT_WS, DISCONNECT_WS } from "../actions.type";
import { SET_CONNECTED_WS } from "../mutations.type";
import { SCREEN } from "@/common/auth.const";

const initialState = {
  websocketURL: `${window.location.protocol}//${window.location.hostname}:${process.env.VUE_APP_API_PORT}/sinop/ws/app`,
  connectedWs: false,
  destination: `/ws/topic/started`,
};

export const state = {
  ...initialState,
};

export const getters = {
  connectedWs: (state) => state.connectedWs,
};

export const mutations = {
  [SET_CONNECTED_WS](state, status) {
    state.connectedWs = status;
  },
};

export const actions = {
  [CONNECT_WS]({ state, commit }) {
    if (state.connectedWs) {
      return;
    }

    this.socket = new SockJS(state.websocketURL);
    this.stompClient = Stomp.over(this.socket);
    this.stompClient.debug = () => {};
    this.stompClient.connect(
      {},
      (frame) => {
        this.stompClient.subscribe(state.destination, (tick) => {
          let ws = JSON.parse(tick.body)["WsExam"];
          console.log(vm.$route.name);
          console.log(vm.$route.params);
          console.log(ws);
          if (
            SCREEN.TEST_USER.NAME === vm.$route.name &&
            parseInt(vm.$route.params.examId) === parseInt(ws.examId)
          ) {
            window.location.replace(window.location.href);
          }
          if (
            SCREEN.EXAM_MANAGEMENT_DETAIL.NAME === vm.$route.name &&
            parseInt(vm.$route.params.id) === parseInt(ws.examId)
          ) {
            window.location.replace(window.location.href);
          }
        });
        commit(SET_CONNECTED_WS, true);
      },
      (e) => {
        console.log(e);
        commit(SET_CONNECTED_WS, false);
      },
    );
  },
  [DISCONNECT_WS]({ state, commit }) {
    if (this.stompClient) {
      this.stompClient.disconnect();
    }
    commit(SET_CONNECTED_WS, false);
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
